const CookiesPolicy = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ textAlign: "center" }}>Polityka Cookies - Checkardi</h1>
      <p>
        Niniejsza Polityka Cookies określa zasady zapisywania i uzyskiwania dostępu do plików cookies
        przez serwis Checkardi.
      </p>

      <h2 style={{ textAlign: "center" }}>§ 1 Definicje</h2>
      <ul>
        <li><strong>Serwis:</strong> serwis internetowy działający pod adresem <a href="https://checkardi.azurewebsites.net">https://checkardi.azurewebsites.net</a></li>
        <li><strong>Administrator:</strong> Natalia Jagiełło, właściciel serwisu Checkardi</li>
        <li><strong>Użytkownik:</strong> osoba korzystająca z Serwisu</li>
        <li><strong>Urządzenie:</strong> elektroniczne urządzenie wraz z oprogramowaniem, za pomocą którego Użytkownik uzyskuje dostęp do Serwisu</li>
        <li><strong>Cookies (ciasteczka):</strong> dane tekstowe gromadzone w formie plików zamieszczanych na Urządzeniu Użytkownika</li>
      </ul>

      <h2 style={{ textAlign: "center" }}>§ 2 Rodzaje Cookies</h2>
      <ul>
        <li><strong>Cookies wewnętrzne:</strong> zamieszczane i odczytywane przez system Serwisu</li>
        <li><strong>Cookies zewnętrzne:</strong> pochodzące od serwisów zewnętrznych (brak obecnie)</li>
        <li><strong>Cookies sesyjne:</strong> są usuwane po zakończeniu sesji przeglądarki</li>
        <li><strong>Cookies trwałe:</strong> pozostają na urządzeniu do momentu ręcznego usunięcia</li>
      </ul>

      <h2 style={{ textAlign: "center" }}>§ 3 Cele wykorzystywania cookies</h2>
      <ul>
        <li>Usprawnienie i przyspieszenie działania serwisu (zapamiętywanie ustawień i preferencji)</li>
        <li>Logowanie użytkowników</li>
      </ul>

      <h2 style={{ textAlign: "center" }}>§ 4 Bezpieczeństwo</h2>
      <p>
        Cookies stosowane przez serwis nie pozwalają na pobieranie danych osobowych ani przenoszenie wirusów. Administrator nie odpowiada za pliki cookies pochodzące od serwisów zewnętrznych.
      </p>

      <h2 style={{ textAlign: "center" }}>§ 5 Zarządzanie cookies</h2>
      <p>
        Użytkownik może w dowolnym momencie samodzielnie zmienić ustawienia przeglądarki dotyczące zapisywania i usuwania cookies. Informacje o sposobie wyłączenia cookies w popularnych przeglądarkach znajdują się na stronie: <a href="http://jakwylaczyccookie.pl">jak wyłączyć cookies</a>.
      </p>

      <h2 style={{ textAlign: "center" }}>§ 6 Wyłączenie odpowiedzialności</h2>
      <p>
        Administrator stosuje wszelkie możliwe środki bezpieczeństwa, ale nie odpowiada za przechwycenie cookies przez osoby trzecie ani skutki ich usunięcia lub wyłączenia przez użytkownika.
      </p>

      <h2 style={{ textAlign: "center" }}>§ 7 Zmiany w Polityce Cookies</h2>
      <p>
        Administrator zastrzega sobie prawo do zmiany Polityki Cookies. Każda zmiana jest publikowana w serwisie i wchodzi w życie z chwilą publikacji.
      </p>
    </div>
  );
};

export default CookiesPolicy;
